import React from "react";
import { useSelector } from "react-redux";
import { EditCompany } from "../Company/Edit-Company";
import { NewCompany } from "../Company/New-Company";

export function EditBranch() {
    const { user } = useSelector((state: any) => state.auth);

    return (
        <EditCompany mainCompanyId={user.companyId} />
    );
}